import React from "react";

import styles from "components/slate/components/DefaultPlaceholder/index.module.scss";

const DefaultPlaceholder = () => {
  return <span className={styles.hint} contentEditable={false} />;
};

export default DefaultPlaceholder;
